import Err from 'models/err';

export default function tooLongError(attrName, length, optLabel) {
  return new Err({
    code: Err.Code.TOO_LONG,
    attr: attrName,
    detail: `${optLabel || attrName} cannot be longer than ${length}`,
  });
}
